module.exports = __webpack_public_path__ + "static/media/reckless-neue-heart-medium.3f6fc45e.woff2";